import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'demo-key'

// Add validation for environment variables
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn('Supabase environment variables not found. Using demo values.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface College {
  id: string
  name: string
  description: string
  location: string
  state: string
  category: string
  stream: string
  rating: number
  fees: string
  cutoff: string
  established: string
  type: string
  image_url: string
  contact_phone?: string
  contact_email?: string
  contact_website?: string
  courses: string[]
  specializations: string[]
  facilities: string[]
  slug: string
  created_at: string
  updated_at: string
  // SEO fields
  meta_title?: string
  meta_description?: string
  meta_keywords?: string
  focus_keyword?: string
  canonical_url?: string
  og_title?: string
  og_description?: string
  og_image?: string
  twitter_title?: string
  twitter_description?: string
  schema_type?: string
  view_count?: number
  review_count?: number
  average_rating?: number
  admission_process?: string
  placement_highlights?: string[]
  notable_alumni?: string[]
}

export interface Review {
  id: string
  college_id: string
  user_id?: string
  author_name: string
  course: string
  year: string
  rating: number
  title: string
  content: string
  helpful_count: number
  approved: boolean
  created_at: string
  updated_at: string
}

export interface BlogPost {
  id: string
  title: string
  slug: string
  excerpt: string
  content: string
  image_url: string
  category: string
  author: string
  author_image?: string
  read_time: string
  tags: string[]
  featured: boolean
  published: boolean
  created_at: string
  updated_at: string
  // SEO fields
  meta_title?: string
  meta_description?: string
  meta_keywords?: string
  focus_keyword?: string
  canonical_url?: string
  og_title?: string
  og_description?: string
  og_image?: string
  twitter_title?: string
  twitter_description?: string
  schema_type?: string
  reading_time_minutes?: number
  view_count?: number
  like_count?: number
}

export interface User {
  id: string
  email: string
  full_name: string
  avatar_url?: string
  role: 'student' | 'admin' | 'counselor'
  created_at: string
  updated_at: string
}

export interface PersonalizedList {
  id: string
  user_id: string
  exam: string
  rank: string
  category: string
  state: string
  preferences?: string
  budget?: string
  college_ids: string[]
  status: 'pending' | 'processed' | 'sent'
  created_at: string
  updated_at: string
}

export interface PersonalizedListSubmission {
  id: string
  name: string
  email: string
  exam: string
  rank: string
  category: string
  states: string[]
  stream: string
  amount_paid: number
  promo_code?: string
  discount_amount: number
  payment_status: 'pending' | 'completed' | 'failed'
  payment_id?: string
  razorpay_order_id?: string
  razorpay_payment_id?: string
  razorpay_signature?: string
  created_at: string
  updated_at: string
}

export interface NewsletterSubscriber {
  id: string
  email: string
  subscribed_at: string
  active: boolean
}

export interface Inquiry {
  id: string
  name: string
  email: string
  subject: string
  message: string
  status: 'new' | 'read' | 'replied'
  created_at: string
  updated_at: string
}

export interface SiteSettings {
  id: string
  key: string
  value: string
  description?: string
  updated_at: string
}

export interface BlogFAQ {
  id: string
  blog_id: string
  question: string
  answer: string
  order_index: number
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface CollegeFAQ {
  id: string
  college_id: string
  question: string
  answer: string
  order_index: number
  is_active: boolean
  created_at: string
  updated_at: string
}